import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const InitGsap = () => {
  const productCards = document.querySelectorAll('.product-card');
  if (productCards.length > 0) {
    productCards.forEach((card) => {
      gsap.fromTo(
        card,
        { yPercent: 5, opacity: 0 },
        {
          yPercent: 0,
          opacity: 1,
          duration: 1,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: card,
            start: 'top 90%',
            toggleActions: 'play none none none',
          },
        }
      );
    });

    async function refreshScrollTriggers(scope = document) {
      // 1) 웹폰트가 있다면 폰트 레이아웃 확정 대기
      if ('fonts' in document) {
        try {
          await document.fonts.ready;
        } catch (e) {}
      }

      // 2) 이미지 로딩 대기 (이미 complete면 패스)
      const imgs = Array.from(scope.querySelectorAll('img'));
      await Promise.all(
        imgs.map((img) =>
          img.complete
            ? Promise.resolve()
            : new Promise((res) => {
                img.addEventListener('load', res, { once: true });
                img.addEventListener('error', res, { once: true });
              })
        )
      );

      // 3) 두 프레임 쉬고 refresh (레이아웃 settle)
      await new Promise((r) =>
        requestAnimationFrame(() => requestAnimationFrame(r))
      );

      ScrollTrigger.refresh();
    }

    // 사용
    window.addEventListener('load', () => {
      refreshScrollTriggers();
    });
  }
};

export default InitGsap;
